import React from 'react';
import styles from "./StepTemplate.module.scss";
import { Typography } from 'seagull';
export function StepTemplate(props) {
  const {
    currentStep,
    stepper,
    header,
    subHeader,
    children,
    footer
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "vob-step-".concat(currentStep),
    className: styles.root
  }, stepper ? /*#__PURE__*/React.createElement("div", {
    "data-testid": "vob-step-".concat(currentStep, "-stepper"),
    className: styles.step
  }, /*#__PURE__*/React.createElement(Typography, null, stepper)) : null, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, header), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    weight: "light",
    skin: "secondary"
  }, subHeader)), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, children, /*#__PURE__*/React.createElement("div", {
    className: styles.footer
  }, footer)));
}